import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getliveClass } from "../../../../service/endpoints";

export const LiveClassHandler = createAsyncThunk('LiveClassHandler', async() => {
    try {
        const response = await getliveClass()
        console.log(response,'class')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
})




const liveClassSlice = createSlice({
    name: 'getLiveClasses',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(LiveClassHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(LiveClassHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(LiveClassHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        })
       
    }

});



export default liveClassSlice.reducer;
